import { COMPONENTS, CoreConfig, DeepPartial, SLOTS } from '@empathybroker/ebx-gluon';

export const MOBILE_CORE_CONFIG: DeepPartial<CoreConfig> = {
  template: COMPONENTS.TEMPLATES.MaxWidthTemplate,
  components: {
    EmptySearch: null,
    ColumnsPicker: null,
    Sort: {
      data: {
        slot: SLOTS.template.footer
      }

    },
    RelatedTags: {
      data: {
        slot: SLOTS.template.toolbar
      }
    },
    SortList: null,
    ResultsNumber: null,

  }
};

export const DESKTOP_CORE_CONFIG: DeepPartial<CoreConfig> = {
  components: {
    Sort: {
      data: {
        slot: SLOTS.template.toolbar
      }
    },
    ResultsNumber: {
      component: COMPONENTS.SMART.ResultsNumber,
      data: {
        slot: SLOTS.template.toolbar
      }
    }
  }
};
